import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { ApprovalOperation } from 'ui-product-approvals-common';
import { View } from 'foundations-components/transitional/components/View';
import { ApprovalRulesRadio } from '../ApprovalRulesRadio';
import { ApproverSelectInput } from '../ApproverSelectInput';
import { ApprovalModalMessage } from './ApprovalModalMessage';
import { ApprovalNoteField } from '../common/ApprovalNoteField';
import { ApprovalDueDateInputGroup } from '../ApprovalDueDateInputGroup';
import { ApprovalTitleTextInput } from '../ApprovalTitleTextInput';
import { LazyApprovalProcessBuilder } from '../approvalProcess/LazyApprovalProcessBuilder';
import { useOutOfOfficeStatuses } from '../../hooks/useOutOfOfficeStatuses';
import { getUnapprovedUserIds } from '../../utils/approvalStepsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const NO_APPROVED_ACTOR_KEYS = new Set();
const NO_USER_IDS = [];
export const ApprovalModalBody = ({
  alertContent,
  approvalRule,
  approvalSteps,
  approvalTitle,
  approvalType,
  approverActors,
  approvers,
  availableApprovalRules,
  canEditApprovalTitle,
  currentOperation,
  requesterActorKey,
  dueDate,
  setDueDate,
  dueTime,
  setDueTime,
  initialNote,
  isDueDateValid,
  setIsDueDateValid,
  isNoteTooLong,
  isOrderedApprovalSteps,
  onChangeApprovers,
  onChangeApprovalRule,
  onChangeApprovalTitle,
  onChangeNote,
  onNoteOverLimit,
  onRemoveApprover,
  superAdminUserIds,
  approvalRuleLocked,
  lockedApproverActorKeys,
  unavailableTemplateApproverActorKeys,
  approvalStepListLocked
}) => {
  const isRequestOperation = currentOperation === ApprovalOperation.REQUEST;
  const outOfOfficeStatuses = useOutOfOfficeStatuses(isRequestOperation && isOrderedApprovalSteps ? getUnapprovedUserIds(approvalSteps.steps, NO_APPROVED_ACTOR_KEYS) : NO_USER_IDS);
  const showApprovalMessage = !(isRequestOperation && canEditApprovalTitle);
  return /*#__PURE__*/_jsxs(DialogBody, {
    maxBlockSize: "calc(100vh - 260px)",
    overflowY: "auto",
    children: [(alertContent || showApprovalMessage) && /*#__PURE__*/_jsxs(View, {
      "data-test-id": "product-approvals-approval-modal-body",
      marginBlockEnd: "300",
      as: "div",
      children: [alertContent && /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "300",
        as: "div",
        children: alertContent
      }), showApprovalMessage && /*#__PURE__*/_jsx(ApprovalModalMessage, {})]
    }), isRequestOperation && /*#__PURE__*/_jsxs(_Fragment, {
      children: [canEditApprovalTitle && /*#__PURE__*/_jsx(ApprovalTitleTextInput, {
        approvalTitle: approvalTitle,
        onChangeApprovalTitle: onChangeApprovalTitle
      }), !isOrderedApprovalSteps && /*#__PURE__*/_jsx(ApproverSelectInput, {
        approvers: approvers,
        value: approverActors,
        onChange: onChangeApprovers
      }), availableApprovalRules.length > 1 && /*#__PURE__*/_jsx(ApprovalRulesRadio, {
        approvalRule: approvalRule,
        onChangeApprovalRule: onChangeApprovalRule,
        isOrderedApprovalSteps: isOrderedApprovalSteps,
        disabled: approvalRuleLocked || approvalStepListLocked
      }), isOrderedApprovalSteps && /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "300",
        paddingBlockStart: "300",
        as: "div",
        children: /*#__PURE__*/_jsx(LazyApprovalProcessBuilder, {
          stages: approvalSteps.steps,
          approvers: approvers,
          approvalRules: approvalRule,
          superAdminUserIds: superAdminUserIds,
          outOfOfficeStatuses: outOfOfficeStatuses,
          requesterActorKey: requesterActorKey,
          canAddStages: !approvalStepListLocked,
          onAddStage: approvalSteps.addStep,
          canRemoveStage: approvalSteps.canRemoveStep,
          onRemoveStage: approvalSteps.removeStep,
          onReorderStages: approvalSteps.setStageOrder,
          onAddApprover: approvalSteps.addApprover,
          canRemoveApprover: approvalSteps.canRemoveApprover,
          onRemoveApprover: onRemoveApprover,
          mode: {
            kind: 'request',
            approvalType,
            stepListLocked: approvalStepListLocked,
            lockedApproverActorKeys,
            invalidApproverActorKeys: unavailableTemplateApproverActorKeys
          }
        })
      }), /*#__PURE__*/_jsx(ApprovalDueDateInputGroup, {
        dueDate: dueDate,
        setDueDate: setDueDate,
        dueTime: dueTime,
        setDueTime: setDueTime,
        isDueDateValid: isDueDateValid,
        setIsDueDateValid: setIsDueDateValid
      })]
    }), /*#__PURE__*/_jsx(ApprovalNoteField, {
      approvalType: approvalType,
      currentOperation: currentOperation,
      initialNote: initialNote,
      isNoteTooLong: isNoteTooLong,
      onChangeNote: onChangeNote,
      onNoteOverLimit: onNoteOverLimit
    })]
  });
};